var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "1200" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "p-0" },
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c(
                "v-flex",
                { attrs: { xs9: "" } },
                [
                  _c("v-icon", [_vm._v(_vm._s(_vm.form.id ? "edit" : "add"))]),
                  _vm._v("\n        Modificar Horario\n      ")
                ],
                1
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    {
                      staticClass: "p-2",
                      staticStyle: { "min-width": "100%" },
                      attrs: { "grid-list-md": "" }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "", row: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { md12: "", xs12: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Descripción",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  outline: "",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.form.descripcion,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "descripcion", $$v)
                                  },
                                  expression: "form.descripcion"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md6: "", xs12: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.tipo_jornada,
                                  "item-value": "id",
                                  "item-text": "tipo",
                                  label: "Ingrese la jornada laboral",
                                  rules: _vm.$validate(["required"]),
                                  outline: "",
                                  disabled: "",
                                  clearable: "",
                                  required: ""
                                },
                                model: {
                                  value: _vm.form.jornada,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "jornada", $$v)
                                  },
                                  expression: "form.jornada"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-chip",
                        { attrs: { color: "#ff5c0a", "text-color": "white" } },
                        [_vm._v("Ingreso ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { wrap: "", row: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { md4: "", xs6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Hora Ingreso ",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  outline: "",
                                  clearable: "",
                                  type: "time"
                                },
                                model: {
                                  value: _vm.form.horario,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "horario", $$v)
                                  },
                                  expression: "form.horario"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md4: "", xs6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Tolerancia en min.",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  outline: "",
                                  clearable: "",
                                  type: "time"
                                },
                                model: {
                                  value: _vm.form.tolerancia_1,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "tolerancia_1", $$v)
                                  },
                                  expression: "form.tolerancia_1"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md4: "", xs6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Rango inicio (Para procesar)",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  outline: "",
                                  clearable: "",
                                  type: "time"
                                },
                                model: {
                                  value: _vm.form.rango_ini,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "rango_ini", $$v)
                                  },
                                  expression: "form.rango_ini"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md4: "", xs6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Rango fin (Para procesar)",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  outline: "",
                                  clearable: "",
                                  type: "time"
                                },
                                model: {
                                  value: _vm.form.rango_fin,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "rango_fin", $$v)
                                  },
                                  expression: "form.rango_fin"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-chip",
                        { attrs: { color: "#3c00ff", "text-color": "white" } },
                        [_vm._v("Salida ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { wrap: "", row: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { md4: "", xs6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Hora salida ",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  outline: "",
                                  clearable: "",
                                  type: "time"
                                },
                                model: {
                                  value: _vm.form.horario_2,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "horario_2", $$v)
                                  },
                                  expression: "form.horario_2"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md4: "", xs6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Tolerancia en min.",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  outline: "",
                                  clearable: "",
                                  type: "time"
                                },
                                model: {
                                  value: _vm.form.tolerancia_2,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "tolerancia_2", $$v)
                                  },
                                  expression: "form.tolerancia_2"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md4: "", xs6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Rango inicio en min. (Para procesar)",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  outline: "",
                                  clearable: "",
                                  type: "time"
                                },
                                model: {
                                  value: _vm.form.rango_ini_2,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "rango_ini_2", $$v)
                                  },
                                  expression: "form.rango_ini_2"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md4: "", xs6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Hora fin en min.(Para procesar)",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  outline: "",
                                  clearable: "",
                                  type: "time"
                                },
                                model: {
                                  value: _vm.form.rango_fin_2,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "rango_fin_2", $$v)
                                  },
                                  expression: "form.rango_fin_2"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("small", { staticClass: "error--text text-required" }, [
                    _vm._v("* Los campos son obligatorios")
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      nativeOn: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("cancel")]),
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.cancel")) + "\n        "
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        type: "submit",
                        loading: _vm.loading,
                        disabled: !_vm.valid
                      },
                      on: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    },
                    [
                      _c("v-icon", { attrs: { dark: "" } }, [_vm._v("check")]),
                      _vm._v(" " + _vm._s(_vm.$t("common.save")) + "\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5067860e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5067860e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/horario/dialogs/ModificarHorario.vue
// module id = null
// module chunks = 